import { useWidgetPortfolioSelectionStatus } from 'widgets/hooks.ts';
import React from 'react';
import { useVolumeCurveConfigSlice } from 'widgets/volumeCurve/store/configuration/configSlice.ts';
import VolumeCurveGrid from 'widgets/volumeCurve/components/grid/VolumeCurveGrid.tsx';
import VolumeCurveChart from 'widgets/volumeCurve/components/chart/VolumeCurveChart.tsx';
import { VolumeCurveData } from 'widgets/volumeCurve/data/volumeCurveData.ts';
import { GridApi } from '@instinet-analytics/semantic-ui-components';
import { useVolumeCurveDimensions } from 'widgets/volumeCurve/components/dimensions.ts';

export function VolumeCurveContent({
    data,
    onGridApiSet,
}: {
    data: VolumeCurveData;
    onGridApiSet: (gridApi: GridApi) => void;
}) {
    const { hasValidSelection } = useWidgetPortfolioSelectionStatus();
    const {
        config: { view },
    } = useVolumeCurveConfigSlice();

    const { bodyHeight } = useVolumeCurveDimensions();

    if (!hasValidSelection) {
        return <></>;
    }

    const haveData = (data?.bucketedData ?? []).length > 0;

    return (
        <div
            className="VolumeCurveContent"
            style={{ height: bodyHeight + 'ps' }}
        >
            {!haveData && <div className="no-data">No data</div>}
            {haveData && (
                <>
                    {view === 'grid' && (
                        <VolumeCurveGrid
                            data={data!}
                            onGridApiSet={onGridApiSet}
                        />
                    )}
                    {view === 'chart' && <VolumeCurveChart data={data!} />}
                </>
            )}
        </div>
    );
}
